export const DataTableEditedEvent = 'data-table-edit';
